import React, { useState, useEffect } from 'react';
import { useReactMediaRecorder } from 'react-media-recorder';
import PopupMSG from './PopupMSG.js';

export default function SpeechRecognitionComponent({ word, onWordComplete }) {
    // const [accuracy, setAccuracy] = useState(null);
    // const [recognition, setRecognition] = useState(null);
    const [showPopup, setShowPopup] = useState(false);


    const {
        error,
        startRecording,
        stopRecording,
        mediaBlobUrl
    } = useReactMediaRecorder({
        video: false,
        audio: true,
        echoCancellation: true,
        blobPropertyBag: { type: 'audio/wav' },
    });

    async function checkIfSilent(mediaBlobUrl) {
        const response = await fetch(mediaBlobUrl);
        const blob = await response.blob();
        const arrayBuffer = await blob.arrayBuffer();

        const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        const audioBuffer = await audioCtx.decodeAudioData(arrayBuffer);

        let rawData = audioBuffer.getChannelData(0); // Use first channel
        let samples = 100; // number of samples to check
        let blockSize = Math.floor(rawData.length / samples);
        let loudness = 0;

        for (let i = 0; i < samples; i++) {
            let blockStart = blockSize * i;
            let sum = 0;
            for (let j = 0; j < blockSize; j++) {
                sum += Math.abs(rawData[blockStart + j]);
            }
            loudness += sum / blockSize;
        }
        loudness = loudness / samples;

        console.log("Loudness:", loudness);

        // Threshold (tweak as needed)
        return loudness < 0.01; // true = silent
    }



    useEffect(() => {
        if (mediaBlobUrl) {
            console.log("Media Blob URL:", mediaBlobUrl);

            setTimeout(async () => {
                const isSilent = await checkIfSilent(mediaBlobUrl);

                if (isSilent) {
                    console.log("No speech detected ❌");
                    onWordComplete(null, 0, [], ""); // handle as "no speech"
                } else {
                    sendAudioToAPI(mediaBlobUrl); // normal processing
                }
            }, 1000);
        }
    }, [mediaBlobUrl]);







    // Function to start speech recognition
    const startRecognition = () => {
        if (!window.SpeechRecognition && !window.webkitSpeechRecognition) {
            alert("Speech recognition is not supported in this browser");
            return;
        }
        // alert(status);

        startRecording();

        setTimeout(() => {
            stopRecording();
        }, 3700); // Delay to ensure recording starts before recognition

        if (error) {
            console.error("Error occurred in recognition: ", error);
            onWordComplete(null, 0, [], '');
            stopRecording();
            return;
        }
        // error((error)=>{
        //     console.log('Error:', error);
        // })
        // const recognitionInstance = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
        // recognitionInstance.lang = "en-IN";
        // recognitionInstance.interimResults = true;
        // recognitionInstance.maxAlternatives = 1;
        // setRecognition(recognitionInstance);
        // recognitionInstance.start();
        // // alert('start1')
        // recognitionInstance.onresult = (event) => {
        //     const spoken = event.results[0][0].transcript.toLowerCase();

        //     let correctWords = 0;
        //     let matchedSyllables = [];

        //     word.syllables.forEach(syllable => {
        //         let word = syllable.toLowerCase();
        //         syllable.toLowerCase();

        //         if (spoken.includes(word)) {
        //             correctWords++;
        //             matchedSyllables.push(syllable);
        //         }
        //     });

        //     const acc = (correctWords / word.syllables.length) * 100;
        //     setAccuracy(acc);
        //     onWordComplete(false, acc, matchedSyllables, spoken); // Notify parent that the word was completed successfully

        //     if (event.results[0].isFinal) {
        //         if (acc >= 50) {
        //             console.log(acc);
        //             onWordComplete(true, acc, matchedSyllables, spoken); // Notify parent that the word was completed successfully
        //         }else{
        //             mediaBlobUrl ? setTimeout(()=>sendAudioToAPI(mediaBlobUrl),1000): console.log('No audio blob URL available');
        //             console.log('1');

        //         }
        //         stopRecording();
        //         recognitionInstance.stop();
        //         // alert('stop1')
        //     }
        // };



        // recognitionInstance.onerror = (event) => {
        //     onWordComplete(null, 0, [], '');
        //     console.error("Error occurred in recognition: ", event.error);
        //     recognitionInstance.stop();
        //     // alert('error1')
        // };

        // recognitionInstance.onspeechend = () => {
        //     recognitionInstance.stop();
        //     console.log("Speech recognition has stopped.");
        //     // alert('end1')
        // };
    };

    async function sendAudioToAPI(mp3Blob) {

        const response = await fetch(mp3Blob);

        const blob = await response.blob();
        const formData = new FormData();
        formData.append('audio', blob, 'audio.wav'); // Append the MP3 file
        formData.append('expectedWord', word.name.toLowerCase()); // Append the expected word


        // if(!Object.keys(formData).length) {
        //     setShowPopup(true);
        //     onWordComplete(null, 0, [], '');
        //     stopRecording();
        //     return;
        // }

        fetch('https://alembicdigilabs.in/medicaldictionary/v1/eyecare/speechtotext', {
            method: 'POST',
            body: formData,
            headers: {
                'authorization': `bearer ${sessionStorage.getItem('token')}`
            }
        })
            .then(response => response.json())
            .then(data => {
                console.log('Audio uploaded successfully:', data)
                if (data.accuracy) {
                    onWordComplete(true, data.accuracy, word.syllables, data.transcribedText);
                } else {
                    onWordComplete(true, 0, [], '');
                    stopRecording();
                }
            })
            .catch(error => {
                console.error('Error uploading audio:', error)
                onWordComplete(true, 0, [], '');
                stopRecording();
            }
            );
    }

    // Call startRecognition as soon as the component mounts
    useEffect(() => {
        // if (recognition) {
        //     recognition.stop();
        // }
        startRecognition();

        // return () => {
        //     if (recognition) {
        //         recognition.stop();
        //     }
        // };
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    return (
        <>
            {showPopup && <PopupMSG icon={error} message={`Please try again. If you're outdoors, speak louder and more clearly to ensure your voice is captured. Also, keep your device closer while speaking.`}
                title={'Unable to Detect Voice!'} />}
        </>
    );
}
